import { useMediaQueryList } from "@hooks/use-media-query";

/**
 * Defines the display mode for bulk action buttons based on screen size and device type.
 */
export type BulkActionsMode =
  /** Full mode: Shows text label + icon in buttons (XL+ desktop) */
  | "full"
  /** Compact mode: Shows only icons, no text labels (MD & LG tablet) */
  | "compact"
  /** Collapsed mode: Shows "..." menu with all actions (XS & SM mobile, or touch devices) */
  | "collapsed";

/**
 * Hook that determines the responsive display mode for bulk action buttons.
 *
 * Automatically calculates the optimal button layout based on screen size and device capabilities
 * using MUI breakpoints. The mode updates reactively when the viewport or device type changes.
 *
 * @returns The current bulk actions display mode (collapsed, compact, or full)
 */
export function useBulkActionsMode(): BulkActionsMode {
  const { isScreenSmOrSmaller, isScreenMd, isHoverSupported } =
    useMediaQueryList();

  switch (true) {
    case !isHoverSupported:
    case isScreenSmOrSmaller:
      return "collapsed";
    case isScreenMd:
      return "compact";
    default:
      return "full";
  }
}
